import './App.css';
import RouteComponent from './Router/RouteComponent';
import Header from './Components/Header';
import Footer from './Components/Footer';
import { Toaster } from "react-hot-toast";
import ScrollToTop from "./scrolltotop";

function App() {
  return (
    <>
      <Toaster/>
      <ScrollToTop />
      <Header />
      <RouteComponent />
      <Footer />

    </>
  );
}

export default App;
